export const formatHour = (hour: any) => {
  let format = hour.split(':')
  const newDate = `${format[0]}:${format[1]}`

  return newDate
}